/**
 * Alarm Location Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */

window.alarmLocationFormatter = function(value, row) {
    let alarmLocation = '';
    switch (row.location_type) {
        case "Ship":
            if (rights.includes("ships.show")) {
                alarmLocation = '<a href="/ships/show/'+row.ship_id+'">'+value+'</a>';
            } else {
                alarmLocation = value;
            }
            break;
        case "Terminal":
            alarmLocation = value;
            break;
        case "Vehicle":
            if (rights.includes("vehicles.show")) {
                alarmLocation = '<a href="/vehicles/show/'+row.vehicle_id+'">'+value+'</a>';
            } else {
                alarmLocation = value;
            }
            break;
    }
    return alarmLocation;
};
